import { Drawer, LinearProgress } from '@material-ui/core';
import { cloneDeep } from 'lodash';
import * as React from 'react';
import { Button } from '../../../../components/button/Button';
import { FlyoutFooter } from '../../../../components/flyout-components/FlyoutFooter';
import { SyncCommandResult } from '../../../../support/models/sync/SyncCommandResult';
import { SupportSvc } from '../../../../support/service';

interface IProps {
    isOpen: boolean;
    onClose: any;
    orders: string;
}

export const SyncStatusFlyout = (props : IProps) => {

    const [service]                            = React.useState(new SupportSvc());
    const [orders, setOrders]                  = React.useState<SyncCommandResult[]>([]);
    
    React.useEffect(() => {
        if (props.isOpen) {
            const orderCpy = cloneDeep(props.orders);
            processSync(orderCpy);
        }
    }, [props.isOpen]);

    const processSync = async (orderStr : string) => {

        const validIds : SyncCommandResult[] = [];

        const ids = orderStr.split('\n');
        if (ids && ids.length > 0) {
            ids.forEach((itm : string) => {
                if (itm && itm.length > 0) {
                    const obj = new SyncCommandResult();
                    obj.orderId = itm;
                    validIds.push(obj);
                }
            });

            setOrders(validIds);
        }
        
        for (let i = 0; i < validIds.length; i++) {

            validIds[i].isLoading = true;
            setOrders([...validIds]);
            
            const result = await service.syncOrder(validIds[i].orderId);
            validIds[i].isLoading = false;
            validIds[i] = result.data;

            setOrders([...validIds]);
        }

    };

    const closeFlyout = () => {
        props.onClose();
    };

    const getSyncOrderStatus = (itm: SyncCommandResult) => {
        if (itm.wasAttempted && !itm.error) {
            return <i className="la la-check-circle success" />;
        }
        else if (!itm.error && !itm.wasAttempted) {
            return <i className="la la-question-circle" />;
        }
        else {
            return <i className="la la-exclamation-circle error" />;
        }
    };

    return (
        <Drawer
            anchor="right"
            onClose={ closeFlyout }
            open={props.isOpen}>
            <div className="stop-action-drawer large backorder-status-flyout">
                <div className="row">
                    <div className="col">
                        <h1>Sync Progress</h1>
                    </div>
                </div>
                    
                <div className="row">
                    <div className="col">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th className="text-center">Order ID</th>
                                    <th className="text-center">Sync Result</th>
                                    <th className="text-center">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    orders.map((itm : SyncCommandResult, idx : number) => 
                                        <tr key={`order-row-${idx}`}>
                                            <td className="text-center">{ itm.orderId }</td>
                                            <td className="text-center">{ getSyncOrderStatus(itm) }</td>
                                            <td className="text-center">
                                                {
                                                    itm.isLoading
                                                        ? <LinearProgress
                                                            classes={{
                                                                colorPrimary: 'btn-progress-indicator-primary',
                                                                barColorPrimary: 'btn-progress-indicator-barcolor'
                                                            }} 
                                                        />
                                                        : itm.error                                                                    
                                                }
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <FlyoutFooter>
                    <div className="row">
                        <div className="col">                            
                            <Button
                                text="Close"
                                classes="action"
                                testID="close-setdate-run-flyout"
                                onBtnClick={ closeFlyout } />
                        </div>
                    </div>
                </FlyoutFooter> 
                
            </div>
        </Drawer>
    );
};
